module.exports = __webpack_public_path__ + "static/media/1POLICY28.5501b452.jpg";